import React, { useEffect, useState } from "react";
import "./home.scss";
import { GoStar } from "react-icons/go";
import { GoStarFill } from "react-icons/go";
import { IoTrashBin } from "react-icons/io5";
import { MdOutlineFileUpload } from "react-icons/md";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";


const EditProduct = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const proId = searchParams.get("proId");
  const typeList = [
    "normal",
    "featured",
    "flashSale",
    "trending",
    "topSelling",
    "roastery",
  ];
  const [name, setName] = useState("");
  const [selectBrand, setSelectBrand] = useState("");
  const [selectCategory, setSelectCategory] = useState("");
  const [selectType, setSelectType] = useState("");
  const [flashSale, setFlashSale] = useState("");
  const [price, setPrice] = useState("");
  const [oldPrice, setOldPrice] = useState("");
  const [stock, setStock] = useState("");
  const [weight, setWeight] = useState("");
  const [barCode, setBarCode] = useState("");
  const [lrCode, setLrCode] = useState("");
  const [discount, setDiscount] = useState("");
  const [description, setDescription] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [outofstock, setOutofstock] = useState(false);
  const [proPhotos, setProPhotos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [brandName, setBrandName] = useState("");
  const [showDelete, setShowDelete] = useState(false);

  const [fromFlashSaleDate, setFromFlashSaleDate] = useState("");
  const [toFlashSaleDate, setToFlashSaleDate] = useState("");
  const [fromFlashSaleTime, setFromFlashSaleTime] = useState("");
  const [toFlashSaleTime, setToFlashSaleTime] = useState("");
  const [flashPrice, setFlashPrice] = useState("");
    const [flashMaxPcs, setFlashMaxPcs] = useState(0);


  useEffect(() => {
    if (!proId) return;

    const getSingleProduct = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`/get-singale-product/${proId}`);
        const product = response.data;

        setName(product.name);
        setSelectBrand(product.brand); // ✅ fix here
        setSelectCategory(
          Array.isArray(product.category)
            ? product.category
            : [product.category] // ✅ fix here
        );
        setSelectType(product.type); // ✅ fix here
        setFlashSale(product.flashSale);
        setPrice(product.price);
        setOldPrice(product.oldPrice);
        setStock(product.stock);
        setWeight(product.weight);
        setBrandName(product.brandName);
        setBarCode(product.barCode);
        setLrCode(product.lrCode);
        setDiscount(product.discount);
        setDescription(product.description);
        setOutofstock(product.outofstock);
        setProPhotos(product.proPhotos);
        setFromFlashSaleDate(product.fromFlashSaleDate);
        setToFlashSaleDate(product.toFlashSaleDate);
        setFromFlashSaleTime(product.fromFlashSaleTime);
        setToFlashSaleTime(product.toFlashSaleTime);
        setFlashPrice(product.flashPrice);
        setFlashMaxPcs(product.flashMaxPcs);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    getSingleProduct();
  }, [proId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const newProduct = {
        name,
        brand: selectBrand,
        category: selectCategory,
        type: selectType,
        price: parseFloat(price),
        oldPrice: parseFloat(oldPrice),
        stock: parseInt(stock),
        weight,
        barCode,
        lrCode,
        discount: parseFloat(discount),
        description,
        outofstock,
        proPhotos,
        brandName,
        fromFlashSaleDate,
        toFlashSaleDate,
        fromFlashSaleTime,
        toFlashSaleTime,
        flashPrice,
        flashSale,
        flashMaxPcs,
      };

      const response = await axios.put(`/update-product/${proId}`, newProduct);
      navigate("/products");
    } catch (error) {
      return;
    }
  };

  useEffect(() => {
    const getCategory = async () => {
      try {
        const response = await axios("/get-category");
        setCategoryList(response.data);
      } catch (error) {
        return;
      }
    };
    getCategory();
  }, []);

  useEffect(() => {
    const getBrand = async () => {
      try {
        const response = await axios("/get-brand");
        setBrandList(response.data);
      } catch (error) {
        return;
      }
    };
    getBrand();
  }, []);

  setTimeout(() => {
    setSuccess(false);
  }, 1000);

  //! add product

  async function uploadPhoto(e) {
    const files = e.target.files;
    const data = new FormData();

    for (let i = 0; i < files.length; i++) {
      data.append("pro", files[i]);
    }

    try {
      setLoading(true); // start loading
      const response = await axios.post(`/proUploads`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      const { data: filenames } = response;
      setProPhotos((prev) => [...prev, ...filenames]);
    } catch (error) {
      console.error("Upload failed:", error);
    } finally {
      setLoading(false); // stop loading
    }
  }

  function removeDoc(e, filename) {
    e.preventDefault();
    setProPhotos([...proPhotos.filter((photo) => photo !== filename)]);
  }

  function selectMainPhoto(e, filename) {
    e.preventDefault();
    const addPhotoWithoutSelected = proPhotos.filter(
      (photo) => photo !== filename
    );
    const newAddedPhotos = [filename, ...addPhotoWithoutSelected];
    setProPhotos(newAddedPhotos);
  }

  const showDeleteHandle =()=>{
    setShowDelete(!showDelete);
  }

  const deleteProduct = async(proId)=>{
    try {
      await axios.delete(`/delete-product/${proId}`)
      navigate("/products");
    } catch (error) {
      return
    }
  }

  return (
    <div className="main_wrp">
      <div className="main_page_wrp">
        <div className="head_wrp">
          <h5>
            Update <em>Product</em>
          </h5>
        </div>
        <div className="main_body_wrp">
          <form onSubmit={handleSubmit}>
            <div className="add_main">
              <div className="add_t_form">
                <div className="in_main">
                  <label>Name</label>
                  <input
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </div>

                <div className="in_main">
                  <label>Brand</label>
                  <select
                    value={selectBrand}
                    onChange={(e) => setSelectBrand(e.target.value)}
                  >
                    <option value="">-- Select Brand --</option>
                    {brandList.map((brand, i) => (
                      <option key={i} value={brand.brand}>
                        {brand.brand}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="in_main">
                  <label>Type</label>
                  <select
                    value={selectType}
                    onChange={(e) => setSelectType(e.target.value)}
                  >
                    <option value="">-- Select Type --</option>
                    {typeList.map((type, i) => (
                      <option key={i} value={type}>
                        {type}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="in_main">
                  <label>Price</label>
                  <input
                    type="number"
                    value={price}
                    disabled
                    step="0.01"
                    onChange={(e) => setPrice(e.target.value)}
                    required
                  />
                </div>

                <div className="in_main">
                  <label>Old Price</label>
                  <input
                    type="number"
                    value={oldPrice}
                    step="0.01"
                    onChange={(e) => setOldPrice(e.target.value)}
                  />
                </div>
                <div className="in_main">
                  <label>Brand Name</label>
                  <input
                    type="text"
                    value={brandName}
                    onChange={(e) => setBrandName(e.target.value)}
                  />
                </div>

                <div className="in_main">
                  <label>Stock</label>
                  <input
                    type="number"
                    disabled
                    value={stock}
                    onChange={(e) => setStock(e.target.value)}
                    required
                  />
                </div>

                <div className="in_main">
                  <label>Weight</label>
                  <input
                    type="text"
                    value={weight}
                    onChange={(e) => setWeight(e.target.value)}
                    required
                  />
                </div>

                <div className="in_main">
                  <label>Bar Code</label>
                  <input
                    type="text"
                    value={barCode}
                    onChange={(e) => setBarCode(e.target.value)}
                  />
                </div>

                <div className="in_main">
                  <label>LR Code</label>
                  <input
                    type="text"
                    value={lrCode}
                    onChange={(e) => setLrCode(e.target.value)}
                  />
                </div>

                <div className="in_main">
                  <label>Discount (%)</label>
                  <input
                    type="number"
                    disabled
                    value={discount}
                    onChange={(e) => setDiscount(e.target.value)}
                  />
                </div>
                <div className="in_main">
                  <label>Out of Stock </label>
                  <input
                    type="checkbox"
                    checked={outofstock}
                    onChange={(e) => setOutofstock(e.target.checked)}
                  />
                </div>
              </div>
              {selectType === "flashSale" && (
                <div className="in_main_long">
                  <div className="flash_sele">
                    <div className="in_main">
                      <label>Flash Sale</label>
                      <select
                        value={flashSale}
                        onChange={(e) => setFlashSale(e.target.value)}
                      >
                        <option value="">-- Select Yes or No --</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                    </div>
                    <div className="in_main">
                      <label>Date From </label>
                      <input
                        type="date"
                        value={fromFlashSaleDate}
                        onChange={(e) => setFromFlashSaleDate(e.target.value)}
                      />
                    </div>
                    <div className="in_main">
                      <label>Time From</label>
                      <input
                        type="time"
                        value={fromFlashSaleTime}
                        onChange={(e) => setFromFlashSaleTime(e.target.value)}
                      />
                    </div>
                    <div className="in_main">
                      <label>Date To</label>
                      <input
                        type="date"
                        value={toFlashSaleDate}
                        onChange={(e) => setToFlashSaleDate(e.target.value)}
                      />
                    </div>

                    <div className="in_main">
                      <label>Time To</label>
                      <input
                        type="time"
                        value={toFlashSaleTime}
                        onChange={(e) => setToFlashSaleTime(e.target.value)}
                      />
                    </div>
                    <div className="in_main">
                      <label>Flash Price</label>
                      <input
                        type="number"
                        min={0}
                        step="0.01"
                        value={flashPrice}
                        onChange={(e) => setFlashPrice(e.target.value)}
                      />
                    </div>

                    <div className="in_main">
                      <label>Max Pcs</label>
                      <input
                        type="number"
                        min={0}
                        value={flashMaxPcs}
                        onChange={(e) => setFlashMaxPcs(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              )}

              <div className="in_main_long">
                <label>Description</label>
                <textarea
                  value={description}
                  rows={5}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </div>
              <div className="in_main_long">
                <div className="h_photo_grid">
                  {proPhotos?.length > 0 &&
                    proPhotos.map((link) => (
                      <div className="h_img_over" key={link}>
                        <img
                          src={`${process.env.REACT_APP_DOC_VIEW_LINK}/` + link}
                          alt="mentora.lk"
                        />
                        <div className="h_trash_icon">
                          <button onClick={(e) => removeDoc(e, link)}>
                            <IoTrashBin style={{ fontSize: "medium" }} />
                          </button>
                        </div>
                        <div className="h_star_icon">
                          <button onClick={(e) => selectMainPhoto(e, link)}>
                            {link === proPhotos[0] && (
                              <GoStarFill
                                style={{
                                  fontSize: "medium",
                                  color: "var(--orange)",
                                }}
                              />
                            )}
                            {link !== proPhotos[0] && (
                              <GoStar style={{ fontSize: "medium" }} />
                            )}
                          </button>
                        </div>
                      </div>
                    ))}
                </div>
                <div className="in_main">
                  <label>Category</label>
                  <div className="checkbox-group">
                    {categoryList.map((category) => (
                      <div key={category._id} className="checkbox-item">
                        <input
                          type="checkbox"
                          id={category._id}
                          value={category.category}
                          checked={selectCategory?.includes(category.category)}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSelectCategory([
                                ...selectCategory,
                                category.category,
                              ]);
                            } else {
                              setSelectCategory(
                                selectCategory.filter(
                                  (item) => item !== category.category
                                )
                              );
                            }
                          }}
                        />
                        <label htmlFor={category._id}>
                          {category.category}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
                {loading ? (
                  <div className="img_uploader">
                    <div className="img_upload_wrp">
                      {loading && (
                        <span style={{ color: "blue" }}>
                          Uploading photos, please wait...
                        </span>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="img_uploader">
                    <div className="img_upload_wrp">
                      <input
                        className="uplodInput"
                        onChange={uploadPhoto}
                        type="file"
                        multiple
                      />
                      <div className="img_upload_wrp_data">
                        <MdOutlineFileUpload color="#5143d9" size={30} />
                        <p>Drop Photo here or click to upload.</p>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div>
                <button type="submit" className="btn_submit_form">
                  <span>Update</span>
                </button>
              </div>

              {error && <small style={{ color: "red" }}>{error}</small>}
              {success && (
                <small style={{ color: "green" }}>
                  Product added successfully!
                </small>
              )}
            </div>
          </form>
          <div className="delete_btn">
            {!showDelete ? (
              <IoTrashBin size={20} onClick={showDeleteHandle} />
            ) : (
              <div className="dlt_wrp">
                <span>Are you sure want to delete ?</span>
                <div className="d_btn" onClick={() => deleteProduct(proId)}>
                  <span>Yes</span>
                </div>
                <div className="d_btn" onClick={showDeleteHandle}>
                  <span>No</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default EditProduct;
